<div [formGroup]="form" class="setting-section-container shadow-sm">
  <div
    class="d-flex"
    [ngbTooltip]="'Settings::AICategoryDiscovery:DisabledTooltip' | abpLocalization"
    [disableTooltip]="form.get('aiCategoryDiscoveryEnabled')?.enabled"
    placement="top-left">
    <div class="align-items-baseline">
      <input
        type="checkbox"
        id="aiCategoryDiscoveryEnabled"
        formControlName="aiCategoryDiscoveryEnabled" />
    </div>
    <div class="col d-block ps-1 pe-0">
      <label
        class="form-check-label"
        for="aiCategoryDiscoveryEnabled"
        [class.text-muted]="form.get('aiCategoryDiscoveryEnabled')?.disabled">
        {{ 'Settings::AICategoryDiscovery:Enable' | abpLocalization }}
      </label>
      <div class="text-muted small">
        {{ 'Settings::AICategoryDiscovery:Description' | abpLocalization }}
      </div>

      @if (form.get('aiCategoryDiscoveryEnabled')?.value) {
        <div class="pt-2">
          <i class="fas fa-info-circle me-2"></i>
          <small
            class="text-muted"
            [innerHTML]="
              'Settings::AICategoryDiscovery:SchemaLanguageInfo'
                | abpLocalization: currentLanguageName
            "></small>
        </div>

        <div class="pt-2">
          <i class="fas fa-info-circle me-2"></i>
          <small
            class="text-muted"
            [innerHTML]="'Settings::AICategoryDiscovery:TrainingInfo' | abpLocalization"></small>
        </div>

        <div class="form-group pt-2">
          <label for="aiCategoryDiscoveryLlmConfigurationId" class="form-label">
            {{ 'Settings::LLMConfiguration:LLMConfiguration' | abpLocalization }}
          </label>
          <ca-select
            [clearable]="true"
            [class]="'below-all'"
            formControlName="aiCategoryDiscoveryLlmConfigurationId">
            <ca-option
              *ngFor="let llmConfiguration of llmConfigurations"
              [value]="llmConfiguration.id">
              {{ llmConfiguration.name }}
            </ca-option>
          </ca-select>
        </div>
      }
    </div>
  </div>
</div>
